import React from "react";
import Header from "@/components/Header";
import bwmodel from '@/config/bwmodel';
import styles from '@/styles'
import styled from "styled-components";
import { jumpTo } from "../../utils";


export const isStorm = bwmodel.app === 'storm';
const Rule = () => {
  
  return <div>

  {isStorm && 
    <Header
      title="活动规则"
      hideNaviBar
      bg_color={styles.bg_color2}
      right={
        <div 
          onClick={()=> {
            jumpTo('https://www.wogoo.com/essay/#/kefu');
          }}
          className="title_right"
        >
          
        {bwmodel.theme === '0' ?      <img src={require('./images/kefu2.png')} alt='' />:     <img src={require('./images/kefu.png')} alt='' />} 
              {/* <img src={require('./images/kefu2.png')} alt='' /> */}
          联系客服
          </div>
      }
    />
  }
  <Container>
  <h2>一、活动时间：</h2>
  <p>2025年9月26日-2025年10月31日；</p>

  <h2>二、活动人群：</h2>
  <p>所有用户均可参与；</p>
  
  <h2>三、抽奖机会获取规则</h2>
  <p>在活动期间完成以下条件都可获得抽奖次数：</p>
  <p>1、每日登录市值风云APP，获得1次；</p>
  <p>2、首次进入抽奖页面，获得2次；</p>
  <p>3、首次分享活动页面，获得1次；</p>
  <p>4、参加实盘比赛，每日报单，获得1次；</p>
  <p>5、每天观看直播超1分钟，获得1次；</p>
  <p>6、每购买一次会员年卡，获得6次（无上限）。</p>
  <p>活动会员类型：风云VIP年卡/研报畅读年卡/短线挖掘年卡/趋势拐点年卡</p>

   <h2> 四、抽奖中的奖品兑现方式：</h2>
   <p>1、<span style={{color: '#FF3E4C'}}>会员时长奖励</span>和<span style={{color: '#FF3E4C'}}>风云周边奖励</span>均需用户在活动期间购买任意会员年卡才可获得，其中会员年卡包含：风云VIP年卡/研报畅读年卡/短线挖掘年卡/趋势拐点年卡。</p>
    <p>2、<span style={{color: '#FF3E4C'}}>会员时长奖励发放：</span>用户每次抽奖所获得的会员奖励天数将实时累加，且奖励天数实时展示在页面底部奖品中（用红色字体标注），例如某用户一共获得31天会员时长奖励，则展示如下图：</p>

    <img src={require('./images/椭1.png')} alt='' className="explain-img" />
   <p> 用户须在活动期间购买会员年卡，才可解锁会员时长奖励奖品。</p>
<p>例如，若用户活动期间获得奖励31天会员奖励，同时该用户在活动期间购买了风云VIP，则该用户在获得31天风云VIP时长奖励，若该用户在活动期间购买的是研报畅读年卡，则该用户获得31天研报畅读时长奖励，若该用户在活动期间同时购买了风云VIP年卡和研报畅读年卡，由于风云VIP权益中已含研报畅读会员权益，所以统一会根据风云VIP的赠送时长进行发放；若用户购买了研报畅读、趋势拐点、短线掘金，都会发放获得的赠送时长。</p>

<p>3、发放时间：</p>
<p>所获得的奖品会在活动结束后10个工作日内发放完成；</p>

<p><b>实物周边奖励</b>《价投全景图》纸质版和“ETF投资地图”“投资笔记”将在活动结束后会统一通过快递形式发送给符合要求的用户，获得以上奖励的用户必须在获得页面及时填写收货信息，否则默认为放弃领取，我们不再通知；</p>
{/* <p>《价投全景图》电子版将在活动结束后通过市值风云App的私信发放给符合要求的用户。</p>
<p>《价投全景图》纸质版和“市值风云专属帆布袋”将在活动结束后会统一通过快递形式发送给符合要求的用户，发送前会通过短信先与您联系，请注意查收短信；</p> */}
<p><b>会员时长奖励</b>活动累计时长将在活动结束后自动结算，并充值进获奖用户的风云账户。</p>

<h2>五、对于以任何不正当方式参与活动的用户。</h2>
 <p>包括但不限干侵犯第三人合法权益、作弊、扰乱系统、实施网络攻击、批量注册、用机器注册账户、用机器模拟客户端等，市值风云有权取消其参与和获得各种奖励的资格，对于非法所得，保留将各种奖励扣回的权利，并对账号进行永久限制。</p>

  <h2>六、本活动最终解释权归市值风云所有。</h2>




</Container>
</div>
}

export default Rule;

const Container = styled.div`
  padding:44px 10px;
  line-height: 1.5;
  p{
    margin: 8px 0;
  }
  img {
    width: 100%;
  }
`


// WEBPACK FOOTER //
// ./src/views/activity_190/rules.js